var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0133 8.61318L14.2983 11.9597L17.6449 15.6746C17.8224 15.8717 17.9144 16.1312 17.9005 16.3961C17.8867 16.6609 17.7683 16.9094 17.5712 17.0869C17.3742 17.2645 17.1147 17.3564 16.8498 17.3426C16.585 17.3288 16.3364 17.2103 16.1589 17.0133L12.8124 13.2983L9.09746 16.6449C8.90041 16.8224 8.64091 16.9144 8.37605 16.9006C8.1112 16.8867 7.86268 16.7683 7.68516 16.5712C7.50765 16.3742 7.41569 16.1147 7.42951 15.8498C7.44332 15.585 7.56179 15.3364 7.75884 15.1589L11.4738 11.8124L8.12721 8.09746C7.9497 7.90041 7.85774 7.64091 7.87155 7.37605C7.88537 7.1112 8.00384 6.86268 8.20089 6.68517C8.39794 6.50765 8.65744 6.41569 8.92229 6.42951C9.18715 6.44332 9.43567 6.56179 9.61318 6.75884L12.9597 10.4738L16.6746 7.12721C16.8717 6.9497 17.1312 6.85774 17.3961 6.87156C17.6609 6.88537 17.9094 7.00384 18.0869 7.20089C18.2645 7.39794 18.3564 7.65744 18.3426 7.92229C18.3288 8.18715 18.2103 8.43567 18.0133 8.61318Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.3c60aae9bb5da8f3592a2ca32d58b7b8.svg";
export { ForwardRef as ReactComponent };